import axios from "axios";

// Stessa origine del sito: funziona identico su apex, www, preview e qualsiasi dominio futuro.
// Solo in sviluppo locale (localhost:3000) si ripiega sull'URL backend da env.
const HOST = window.location.hostname;
const ORIGIN = HOST === "localhost" || HOST === "127.0.0.1" ? process.env.REACT_APP_BACKEND_URL : window.location.origin;

export const API = `${ORIGIN}/api`;

export const api = axios.create({
  baseURL: API,
  withCredentials: true,
});

export const twitchLoginUrl = `${API}/auth/twitch/login`;

export const discordLoginUrl = `${API}/auth/discord/login`;
